import { schema } from 'normalizr';

const CommandScheduleSchema = new schema.Entity('commandSchedules', {});

export { CommandScheduleSchema };
